import { Box, Typography } from '@mui/material';
import typography from '../../styles/typography.module.css';
import layout from '../../styles/layout.module.css';
import { useTranslation } from 'react-i18next';

export const DriverCount = ({ model, drivers }) => {
    const { t } = useTranslation();
    const driverList = Object.values(drivers);
    const driverCount = t(`${model}.driver_count`);
    const info =
        driverCount.localeCompare(`${model}.driver_count`) === 0 || driverCount === undefined ? (
            driverList.map((driver) => {
                return (
                    <span className={typography.modelDescription} key={driver.name}>
                        {driver.count} {driver.name}
                    </span>
                );
            })
        ) : (
            <span className={typography.modelDescription}>{driverCount}</span>
        );
    return (
        <Box
            className={layout.subSectionContainer}
            container
            sx={{
                display: 'flex',
                flexWrap: 'wrap',
                color: 'text.primary',
                alignItems: 'center',
                width: '100%'
            }}>
            <Typography>
                <span className={typography.modelDescriptionSubTitle}>
                    {t('model.driver_count')}:{' '}
                </span>
                {info}
            </Typography>
        </Box>
    );
};
